import { DataTableColumnHeader } from "@/components/ui";
import { type DirectoryUser } from "@/lib/types";
import { formatLocalOrIntlPhoneNumber } from "@/lib/utils/format";
import { renderCheckedCell } from "@/lib/utils/tableUtils";
import { type ColumnDef } from "@tanstack/react-table";

export const userTableColumns: ColumnDef<DirectoryUser>[] = [
  {
    accessorFn: (row) => row.firstName + " " + row.lastName,
    id: "Name",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
  },
  {
    accessorFn: (row) => row.middleName ?? "-",
    id: "Middle Name",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
  },
  {
    accessorFn: (row) => row.email,
    id: "Email",
    enableHiding: false,
    header: ({ column }) => <DataTableColumnHeader column={column} />,
  },
  {
    accessorFn: (row) => row.phoneNumber,
    id: "Phone Number",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
    cell: ({ row }) =>
      row.original.phoneNumber
        ? formatLocalOrIntlPhoneNumber({ number: row.original.phoneNumber })
        : "-",
  },
  {
    accessorFn: (row) => (row.enabled ? "Active" : undefined),
    id: "Enabled",
    header: ({ column }) => <DataTableColumnHeader column={column} />,
    cell: (props) => renderCheckedCell<DirectoryUser>({ props, showX: true }),
  },
];
